export const stationFilterBase = /^[\w\d]{8}$/;

export const stationHashRegExp = /^[\w\d]{5}$/;

export const stationIdRegExp = /^[\w\d]{8}-[\w\d]{4}-[\w\d]{4}-[\w\d]{4}-[\w\d]{12}$/;
